import { Box, Divider, Typography } from "@drone-js/core";
import type { PropertySelectionItem as HmPropertySelectionItem } from "libs/codegen/homes-onbaording";
import type { PropertySelectionItem } from "libs/codegen/property-onboarding";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { ImportedListing } from "./ImportedListing";
import { PropertySelectionStatus } from "./constants";
import { usePropertiesValue } from "./propertiesAtom";
import { ApiPropertyStatus } from "./types";

export const ImportedSection = () => {
    const {
        automaticPropertySelectionCms: { importedTitle, importedSubtitle },
    } = usePropertySelectionViewModelValue();
    const properties = usePropertiesValue();
    const propertiesOfInterest = properties.filter(
        (p) =>
            p.status === PropertySelectionStatus.Active ||
            p.status === PropertySelectionStatus.Publishing ||
            p.status === PropertySelectionStatus.Draft,
    );

    if (propertiesOfInterest.length === 0) return null;

    return (
        <Box data-element-name="imported-section">
            <Divider mb="32" />
            <Box mb="16">
                <Typography variant="heading-l" textColor="base.default">
                    {importedTitle}
                </Typography>
                <Typography variant="body-s" textColor="base.subtle" pt="8">
                    {importedSubtitle.replace("{0}", propertiesOfInterest.length.toString())}
                </Typography>
            </Box>
            <Box mb="32">
                {propertiesOfInterest.map((p) => (
                    <ImportedListing
                        key={`imported-${p.id}`}
                        title={p.name}
                        subTitle={p.location}
                        image={(p as HmPropertySelectionItem)?.imageUrl ?? (p as PropertySelectionItem)?.image}
                        status={p.status}
                        url={
                            p.status === ApiPropertyStatus.Active
                                ? `https://www.agoda.com/pages/agoda/default/page_hotel.aspx?hotel_id=${p.id}`
                                : undefined
                        }
                        id={p.id}
                    />
                ))}
            </Box>
        </Box>
    );
};
